import {FormattedRealDate} from '../../common/components/FormattedDate.js'
import ButtonLink from '../../common/components/Button/ButtonLink.js'
import {transferSelector} from '../../data/transfers.js'
import {showTransferNotesModal} from '../TransferListPage/Modals/EditTransferParamModal.js'
import {transferDetailTransferIDSelector} from './transferDetailFunctions.js'
import {useSelector} from '../../store.js'
import {Count, Plural, PluralBlock} from '../../common/components/Plural.js'
import {getWarehouseName, warehousesSelector} from '../../data/warehouses.js'
import {formatDateTime} from '../../common/date.js'

export default function Sidebar() {
  const transferID = useSelector(transferDetailTransferIDSelector)
  const warehousesByID = useSelector(warehousesSelector)
  const transfer = useSelector((state) => transferSelector(state, {transferID}))

  const sendingWarehouse = warehousesByID[transfer.sending_warehouse.id]
  const receivingWarehouse = warehousesByID[transfer.receiving_warehouse.id]

  return (
    <>
      <div className="wrap--batch-info-panel">
        <div className="inner-wrap__panel--actions">
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Transfer ID</dt>
            <dd className="list__item--product-data margin-bottom-0">
              <strong className="fs-02 v-align-middle margin-right-10">
                {transferID}
              </strong>
            </dd>
          </dl>
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Date Created</dt>
            <dd className="list__item--product-data margin-bottom-0">
              <strong>
                <FormattedRealDate
                  value={transfer.created}
                  format={formatDateTime}
                />
              </strong>
            </dd>
            <dd className="list__item--product-data">
              <em className="fs-n0 op-50">
                Updated:{' '}
                <FormattedRealDate
                  value={transfer.updated}
                  format={formatDateTime}
                />
              </em>
            </dd>
          </dl>
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Contents</dt>
            <dd className="list__item--product-data">
              <strong className="fs-01 lh-sm-md">
                <PluralBlock array={transfer.lines}>
                  <Count /> <Plural word="SKU" />
                </PluralBlock>
              </strong>
            </dd>
          </dl>
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Sending Warehouse</dt>
            <dd className="list__item--product-data">
              <strong className="fs-01 lh-sm-md">
                {getWarehouseName(sendingWarehouse)}
              </strong>
            </dd>
          </dl>
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Receiving Warehouse</dt>
            <dd className="list__item--product-data">
              <strong className="fs-01 lh-sm-md">
                {getWarehouseName(receivingWarehouse)}
              </strong>
            </dd>
          </dl>
          <dl className="list divider--bottom">
            <dt className="list__title--order-data">Notes</dt>
            {transfer.transfer_notes ? (
              <dd className="list__item--order-data ws-pre-wrap fs-n0">
                <div>{transfer.transfer_notes}</div>
                <ButtonLink
                  className="fs-n0 meta-batchlist-button-edit-internal-note"
                  onClick={() => showTransferNotesModal(transferID)}
                >
                  Edit
                </ButtonLink>
              </dd>
            ) : (
              <dd className="list__item--order-data">
                <ButtonLink
                  className="fs-n0 meta-batchlist-button-add-internal-note"
                  onClick={() => showTransferNotesModal(transferID)}
                >
                  Add note
                </ButtonLink>
              </dd>
            )}
          </dl>
        </div>
      </div>
    </>
  )
}
